import React from 'react';
import {nanoid} from 'nanoid';
import {curry} from 'ramda';
import {Label} from '../../QCTools/QCToolsMetadata/QCToolsMetadataTypes';

export const mapToFilmLabel = curry((classname: string, filmLabel: Label): JSX.Element => {
    const {label} = filmLabel;
    return (
        <div
            className={classname}
            key={nanoid()}
        >
            <span>{label}</span>
        </div>
    );
});

export const getFilmLabels = (labels: Label[] | undefined, classname: string): JSX.Element[] | null => {
    if (!labels)
        return null;
    
    return labels.map(mapToFilmLabel(classname));
};

